import { Button, Stack } from '@mantine/core';

import CustomPasswordInput from '../../CustomPasswordInput';

import { useResetPasswordFormContext } from '../../../contexts/forms';

import { PASSWORD_REQUIREMENTS } from '../../../constants/signUpForm';

import { BaseFormProps } from '../../../@types/global';

export default function ResetPasswordForm({
  onSubmit,
  isSubmitting = false,
}: BaseFormProps) {
  const form = useResetPasswordFormContext();

  return (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Stack gap="lg">
        <CustomPasswordInput
          enableStrengthMeter
          label="Password"
          autoComplete="new-password"
          popoverProps={{
            position: 'bottom-start',
          }}
          disabled={isSubmitting}
          {...PASSWORD_REQUIREMENTS}
          {...form.getInputProps('password')}
        />
        <CustomPasswordInput
          label="Confirm Password"
          autoComplete="new-password"
          disabled={isSubmitting}
          {...form.getInputProps('password_confirmation')}
        />
        <Button fullWidth type="submit" loading={isSubmitting}>
          Set New Password
        </Button>
      </Stack>
    </form>
  );
}
